import { render, staticRenderFns } from "./ViewVideos.vue?vue&type=template&id=35ef192a&scoped=true"
import script from "./ViewVideos.vue?vue&type=script&lang=js"
export * from "./ViewVideos.vue?vue&type=script&lang=js"
import style0 from "./ViewVideos.vue?vue&type=style&index=0&id=35ef192a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ef192a",
  null
  
)

export default component.exports